import axios from 'axios';

const url = process.env.VUE_APP_API_BASE_URL + '/client-analytics';

function getClientAnalytics(params) {
    let queryString = `${url}?`;
    for (const key in params) {
        if (params.hasOwnProperty(key)) {
            queryString += `${key}=${encodeURIComponent(params[key])}&`;
        }
    }
    queryString = queryString.slice(0, -1);

    return axios.get(queryString)
        .then(response => {
            return {
                clientAnalytics: response,
            };
        }).catch(err => {
            return {
                clientAnalytics: err.response,
            };
        });
}

function sendUplChunk(payload) {
    const url = 'https://orders.fixthephoto.com/tmp/ophotos/upl_chunk.php';
    const options = {
        // headers: {
        //     'Content-Type': 'multipart/form-data'
        // }
    };

    return axios.post(url, payload, options).then(response => {
        return {
            sendUplChunk: response
        };
    });
}

export default {
    getClientAnalytics,
    sendUplChunk
};